import type { SupabaseClient } from '../supabase/client';
import type { AdminShippingLabelOrder, OrderErrorKey } from '../types/order';

export async function getAdminShippingLabelOrder(
  client: SupabaseClient,
  orderId: string,
): Promise<AdminShippingLabelOrder> {
  const { data, error } = await client.rpc('get_admin_shipping_label_order', {
    target_order_id: orderId,
  } as never);
  if (error) throw error;
  if (!data) throw new Error('get_admin_shipping_label_order: empty result');
  return data as unknown as AdminShippingLabelOrder;
}

export function mapAdminShippingLabelError(err: unknown): OrderErrorKey {
  if (!err || typeof err !== 'object') return 'order.errors.unknown';
  const maybe = err as {
    readonly code?: string;
    readonly message?: string;
    readonly details?: string;
  };
  const text = `${maybe.message ?? ''} ${maybe.details ?? ''}`;
  if (maybe.code === '42501') return 'order.errors.transitionUnauthorized';
  if (maybe.code === 'P0002') return 'order.errors.orderNotFound';
  if (/DELIVERY_FULFILLMENT_ONLY/.test(text)) {
    return 'admin.orders.fulfillment.deliveryOnly';
  }
  if (/MANUAL_APPROVAL_REQUIRED|manual approval/i.test(text)) {
    return 'order.errors.manualApprovalRequired';
  }
  if (/network|fetch|abort/i.test(text)) return 'order.errors.networkFailed';
  return 'order.errors.unknown';
}
